import { setAxiosDefaultHeaders } from './core/helpers/axios';
import { setMomentLocale } from './core/helpers/moment';
setAxiosDefaultHeaders();
setMomentLocale();
